import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { fetchManagedByJobTitles } from "../../thunks/addUserThunk";

export const initialState: FetchingItemsState<string> = {
  isLoading: false,
  items: [],
  itemsCount: 0,
};

const managedByJobTitlesSlice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.EditAccount,
    name: "ManagedByJobTitles",
    namespace: ReducerNamespaceTypes.Accounts,
  },
  thunk: fetchManagedByJobTitles,
  reducers: {},
});

export default managedByJobTitlesSlice.reducer;
